import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import utils from "../utils/Utils";
import axios from 'axios';
import config from '../config';
import Layout from '../layout/Layout';
import Form from '../components/Form';
import PageLogo from '../components/PageLogo';
import PageTitle from '../components/PageTitle';
import FormField from '../components/FormField';
import PasswordHints from '../components/PasswordHints';
import ShowErrors from '../components/ShowErrors';
import ButtonSubmit from '../components/ButtonSubmit';
import LoginGoogle from '../components/LoginGoogle';
import LoginFacebook from '../components/LoginFacebook';

const Signup = ({ setCurrentPage }) => {
    // const navigate = useNavigate()
    const { user, setUser, loginUser } = useUser();;
    const [loading, setLoading] = useState(false);
    const [hints, setHints] = useState([]);
    const [errors, setErrors] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Transform the name field to title case
        if (name === 'name') {
            const titleCaseValue = utils.toTitleCase(value);
            setUser((prevUser) => ({
                ...prevUser,
                [name]: titleCaseValue,
            }));
        } else if (name === 'email') {
            setErrors([]);
            setUser((prevUser) => ({
                ...prevUser,
                [name]: value.toLowerCase(),
            }));
        } else {
            setUser((prevUser) => ({
                ...prevUser,
                [name]: value,
            }));
        }

        // if (name === 'password') {
        //     setHints([]);
        //     if (value.length > 0) {
        //         const hints = utils.validatePassword(value);
        //         if (hints.length > 0) {
        //             setHints(hints);
        //         }
        //     }
        // }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value.trim(),
        }));

        if (name === 'email') {
            setErrors([]);
            const errors = utils.validateEmail(user.email);
            if (errors.length > 0) {
                setErrors(errors);
                return;
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log(user.password);
        setHints([]);
        const hints = utils.validatePassword(user.password);
        if (hints.length > 0) {
            setHints(hints);
            return;
        }

        setErrors([]);
        const errors = utils.validateEmail(user.email);
        if (errors.length > 0) {
            setErrors(errors);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${config.apiBaseUrl}/auth/signup`, user);
            if (response.status === 200){
                // console.log(response.data);
                // console.log('User created successfully');

                utils.toastVerify(`Welcome to ${config.appName}!!`);

                loginUser(response.data);
                // navigate("/");
                setCurrentPage('profile');
            }
        } catch (error) {
            errors.push(error.response?.data?.detail[0]['msg'] ?? 'Failed to create user');
            setErrors(errors);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Form handleSubmit={handleSubmit}>
                <PageLogo />
                <PageTitle pageTitle={"Sign Up"} />

                <FormField
                    label={"Name"}
                    name={"name"}
                    type={"text"}
                    value={user.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    autoFocus={true}
                />

                <FormField
                    label={"Email"}
                    name={"email"}
                    type={"email"}
                    value={user.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                />

                <FormField
                    label={"Password"}
                    name={"password"}
                    type={"password"}
                    value={user.password}
                    autoComplete="current-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                />

                <PasswordHints hints={hints} />
                <ShowErrors errors={errors} />
                
                <ButtonSubmit 
                    loading={loading} 
                    labeling={'Signing in ...'} 
                    label={'Sign Up'} 
                    // disabled={loading || hints.length > 0 || errors.length > 0}
                />

                <div className="mt-4 text-gray-200 text-center">
                    Already have an account?{" "}
                    <button
                        key='login'
                        onClick={() => setCurrentPage('login')}
                        className="text-orange-300 hover:underline"
                    >
                        Please Login
                    </button>
                </div>

                <div className="border-t text-gray-200 my-4 text-center">
                    Or, sign up using below:
                </div>

                <div className='flex justify-center items-center'>
                    <LoginGoogle/>

                    <LoginFacebook
                        setLoading={setLoading}
                    />
                </div>
            </Form>
        </Layout>
    );
};

export default Signup;

